<template>
  <div class="workspace">
    <template v-if="initialized">
      <Header
        :teams="computedProfileTeams"
        :profile="profileMe"
        :count-messages="countNewMessages"
        @create-team="onCreateTeam"
        @logout="onLogout"
      />
      <div class="container-fluid header-image" />
      <b-modal
        ref="editprofile"
        hide-footer
        size="lg"
        title="Create Team Profile"
        @hide="onModalHide(process.editTeam, $event)"
      >
        <edit-team-profile
          create
          :profile-me="profileMe"
          :profiles="profiles"
          @before-submit="process.editTeam=true"
          @submit-failed="process.editTeam=false"
          @submitted="process.editTeam=false; $refs.editprofile.hide()"
        />
        <b-overlay :show="process.editTeam" no-wrap opacity=".5" />
      </b-modal>
      <section>
        <b-container>
          <b-row no-gutters>
            <component
              :is="leftSide"
              id="nav-collapse"
              cols="auto"
              :class="['left-panel', {
                'left-panel-scroll': !mobileView && fitLeftSide,
                'left-panel-sticky': !mobileView
              }]"
              is-nav
            >
              <keep-alive>
                <teams-list />
              </keep-alive>
            </component>
            <b-col>
              <router-view />
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/Header'
import TeamsList from './TeamsList'
import EditTeamProfile from './EditTeamProfile'

export default {
  name: 'Workspace',

  computed: {
    ...mapGetters([
      'profileMe',
      'profileTeams',
      'profiles',
      'countNewMessages'
    ]),

    computedProfileTeams() {
      return this.profileTeams(this.profileMe.id)
    },

    companySlug() {
      return this.$route.params.companySlug
    },

    leftSide() {
      return this.mobileView ? 'b-sidebar' : 'b-col'
    }
  },

  data() {
    return {
      initialized: false,
      mobileView: false,
      fitLeftSide: false,
      process: {
        editTeam: false
      },
      messageTimeout: null
    }
  },

  async mounted() {
    this.handleView()
    window.addEventListener('resize', this.handleView)
    window.addEventListener('scroll', this.handleScroll)

    this.initialized = false
    try {
      await Promise.all([
        this.$store.dispatch('fetchCompany', this.companySlug),
        this.$store.dispatch('fetchCompanyAdmins'),
        this.$store.dispatch('fetchProfileMe')
      ])
    } catch {
      this.$router.push({ name: 'Login' })
    } finally {
      this.initialized = true
    }

    this.pullNewMessages()
    this.messageTimeout = setInterval(this.pullNewMessages, 60000)
  },

  destroyed() {
    window.removeEventListener('resize', this.handleView)
    window.removeEventListener('scroll', this.handleScroll)
    clearInterval(this.messageTimeout)
  },

  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 992
    },

    handleScroll() {
      this.fitLeftSide = window.scrollY > 70
    },

    onCreateTeam() {
      this.$refs.editprofile.show()
    },

    onModalHide(process, e) {
      if (process) {
        e.preventDefault()
      }
    },

    pullNewMessages() {
      this.$store.dispatch('fetchCountNewMessages')
    },

    async onLogout() {
      await this.$store.dispatch('signOut')
      await this.$store.dispatch('clear')
      this.$router.push({ name: 'Login' })
    }
  },

  components: {
    Header,
    TeamsList,
    EditTeamProfile
  }
}
</script>
